import { InvestmentMemo, SupportingDocType } from '../../types';

// Mock Investment Memos
export const mockInvestmentMemos: InvestmentMemo[] = [
  {
    id: '1',
    title: 'Retail Portfolio Acquisition',
    createdDate: '2023-02-22T10:00:00Z',
    createdBy: '1',
    lastModified: '2023-02-28T15:30:00Z',
    dealSummary: 'Acquisition of a 3-property retail portfolio in the Midwest with strong anchor tenants and stable cash flow.',
    risks: 'Potential tenant turnover in 2025 (15% of GLA). E-commerce impact on brick-and-mortar retail.',
    terms: 'Purchase price: $45M. Cap rate: 6.2%. Financing: 65% LTV at 4.5% fixed for 7 years.',
    returns: 'Projected IRR: 14.2%. Equity multiple: 1.8x over 5-year hold.',
    supportingDocs: [
      {
        id: 's1',
        name: 'Retail Portfolio OM.pdf',
        type: SupportingDocType.OfferingMemorandum,
        uploadDate: '2023-02-20T14:45:00Z',
      },
      {
        id: 's2',
        name: 'Retail Portfolio Model.xlsx',
        type: SupportingDocType.Model,
        uploadDate: '2023-02-21T09:30:00Z',
      },
    ],
    version: 2,
  },
];
